import useDataTransform from './useDataTransform.js'

import { AgCharts } from 'ag-charts-react'

export default function AgChart(props) {
  let options = useDataTransform(props, {})

  return <AgCharts options={options} />
}
